import { Card } from "@components/cards/card";
import { api } from "@service/api";
import Skeleton from "react-loading-skeleton";
import { useEffect, useState } from "react";
import {
  IRafflePublicListDTO,
  RaffleStatusTypes,
} from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { ProgressBar } from "react-bootstrap";
import {
  getRaffleStatus,
  raffleStatusSelect,
} from "@hooks/functions/Raffle/status";
import dayjs from "dayjs";
import { Link, useParams } from "react-router-dom";
import { FaBroom, FaExpand, FaMinus, FaRegCopy } from "react-icons/fa6";
import { Masks } from "@hooks/functions/Masks/Masks";
import { getRaffleType } from "@hooks/functions/Raffle/type";
import { clickToCopy } from "@hooks/functions/Misc/ClickToCopy";
import { Pagination } from "@components/pagination";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { IRaffleDefaultTypeDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { RaffleStatusEnum } from "@hooks/enums/raffle";
import { Input } from "@components/forms/input";
import { Select } from "@components/forms/select";
import { formatName } from "@hooks/functions/formatName";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";

const masks = new Masks();
export function CampaignDefaultCustomerList() {
  // Plugins & Functions
  const { atsign } = useParams();
  const { customer } = ZuAuthStore();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // Control Things & General Configs
  const [isLoading, setIsLoading] = useState<{ raffles: boolean }>({
    raffles: true,
  });
  const [raffles, setRaffles] = useState<IRafflePublicListDTO[]>([]);

  // Pagination Part
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [order, setOrder] = useState("DESC");
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // --- Another Control --- //
  const [show, setShow] = useState<{ filter: boolean }>({
    filter: false,
  });

  // Filters
  const [status, setStatus] = useState<RaffleStatusTypes | "">(
    RaffleStatusEnum.ACTIVE,
  );
  const [type, setType] = useState<IRaffleDefaultTypeDTO>();
  const [searchCampaign, setSearchCampaign] = useState<string | undefined>();
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");

  async function handleCampaignList() {
    try {
      const params = `?${new URLSearchParams(
        Object.entries({
          page: (page || 1).toString(),
          take: take.toString(),
          order,
          ...(atsign && { atsign }),
          ...(status && { status }),
          ...(searchCampaign && { searchCampaign }),
          ...(startAt && { startAt }),
          ...(endAt && { endAt }),
        }),
      ).toString()}`;
      const result = await api.get(`/raffle/default/list${params}`);
      // console.log({ r: result.data });

      setTotal(result.data.total);
      setRaffles(result.data.result);
      setTotalPages(Math.ceil(Number(result.data.total / take)) || 1);

      setIsLoading((prev) => ({
        ...prev,
        raffles: false,
      }));
    } catch (err: any) {
      pushToastify({
        message: err?.response?.data.message ?? "",
        type: "error",
        theme: "dark",
      });
    }
  }

  async function cleanFilters() {
    // --- Main Filters --- //
    setStatus(RaffleStatusEnum.ACTIVE);
    setSearchCampaign(undefined);

    // --- Anothers --- //
    setStartAt("");
    setEndAt("");
    handleCampaignList();
  }

  useEffect(() => {
    setIsLoading((prev) => ({
      ...prev,
      raffles: true,
    }));

    handleCampaignList();
  }, [page, order, take, status]);

  return (
    <>
      {/* Filters */}
      <div className="row">
        <div className="col-md-12">
          <Card>
            <div
              className="card-header"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShow((prev) => ({
                  ...prev,
                  filter: !show.filter,
                }));
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="">
                  <div className="card-title">Filtrar Campanhas</div>
                  <div className="card-category">
                    Utilize o filtro para trazer um período específico.
                  </div>
                </div>
                <div className="">
                  {show.filter ? (
                    <FaMinus
                      className="fs-5"
                      title="Clique para ocultar as informações."
                    />
                  ) : (
                    <FaExpand
                      className="fs-5"
                      title="Clique para visualizar as informações."
                    />
                  )}
                </div>
              </div>
            </div>
            <div className={`card-body ${show.filter ? `` : `d-none`}`}>
              {/* Another Filters */}
              <div className="row mt-2">
                <div className="col-md-3">
                  <Input
                    animated
                    label="Nome da Campanha"
                    placeholder=""
                    type="text"
                    value={searchCampaign || ""}
                    onChange={(e) => {
                      setSearchCampaign(e.target.value);
                    }}
                    onKeyUp={(e) => e.key === "Enter" && handleCampaignList()}
                  />
                </div>
                {/* Status */}
                <div className="col-md-3">
                  <Select
                    animated
                    label="Status da Campanha"
                    className="form-select form-control"
                    aria-label="status"
                    value={status || ""}
                    options={[
                      { value: "", name: "Todos" },
                      ...raffleStatusSelect.map((x) => ({
                        value: x.status,
                        name: x.text,
                      })),
                    ]}
                    onChange={(e) => {
                      setStatus(e.target.value as RaffleStatusTypes | "");
                    }}
                  />
                </div>
                {/* Dates */}
                <div className="col-md-3">
                  <Input
                    animated
                    id="startAt"
                    label="Data Inicial"
                    placeholder=""
                    type="date"
                    value={startAt}
                    onChange={(e) => setStartAt(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    animated
                    id="endAt"
                    label="Data Final"
                    placeholder=""
                    type="date"
                    value={endAt}
                    onChange={(e) => setEndAt(e.target.value)}
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="row d-flex justify-content-end mt-2">
                <div className="col-md-2">
                  <div className="d-flex justify-content-between">
                    <div className="form-group">
                      <button
                        className="btn btn-sm btn-success form-control rounded px-5"
                        onClick={() => handleCampaignList()}
                      >
                        Filtrar
                      </button>
                      <small className="text-muted ms-1"> </small>
                    </div>
                    <div className="form-group">
                      <button
                        className="btn btn-sm btn-warning form-control rounded text-white"
                        onClick={cleanFilters}
                        title="Limpar todos os filtros."
                      >
                        <FaBroom />
                      </button>
                      <small className="text-muted ms-1"> </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <Card className="CampaignList" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="card-header" style={{ backgroundColor: "#ffffff" }}>
          <div className="row d-flex flex justify-content-between">
            <div className="col-md-8">
              <div className="card-title">Lista de Campanhas</div>
              <div className="card-category">
                Listagem de todas as Campanhas da Plataforma
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex flex justify-content-end align-items-center">
                {/* Sort order */}
                <div className="me-2">
                  <Select
                    animated
                    label="Ordenação"
                    className="form-select form-control"
                    aria-label="status"
                    value={order}
                    options={[
                      { value: "DESC", name: "Recentes" },
                      { value: "ASC", name: "Antigas" },
                    ]}
                    onChange={(e) => {
                      setOrder(e.target.value);
                    }}
                  />
                </div>
                {/* New Raffle */}
                <div className="">
                  <Link
                    className="btn btn-sm btn-success"
                    to={`/raffle/default/new`}
                  >
                    Criar Campanha
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body" style={{ backgroundColor: "#f8f9fa" }}>
          {isLoading.raffles ? (
            <Skeleton count={4} height={25} borderRadius={5} />
          ) : (
            <>
              <div className="row d-flex flex">
                {raffles.length === 0 ? (
                  <div className="d-flex justify-content-center">
                    <span className="h5">Nenhum registro encontrado.</span>
                  </div>
                ) : (
                  <>
                    {raffles.map((raffle, index) => {
                      const raffleStatus = getRaffleStatus(
                        raffle?.status as RaffleStatusTypes,
                      );
                      const raffleType = getRaffleType(raffle?.type);
                      const isMyCampaign =
                        customer && customer.customer.id === raffle.customer;

                      // --- Card Config --- //
                      const myOwnRaffle =
                        customer?.customer.id === raffle.customer;
                      const border = {
                        default: myOwnRaffle
                          ? "2px solid #0dcaf0"
                          : "1px solid #e5e7eb",
                        hover: myOwnRaffle
                          ? "2px solid #d1d5db"
                          : "1px solid #e5e7eb",
                      };
                      return (
                        <div
                          key={index}
                          className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4"
                          style={{
                            animation: `fadeInUp 0.5s ease-out ${index * 0.08}s both`,
                          }}
                        >
                          <Card
                            className=""
                            style={{
                              transition:
                                "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              backgroundColor: "#ffffff",
                              borderRadius: "12px",
                              overflow: "hidden",
                              border: border.default,
                              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform =
                                "translateY(-4px)";
                              e.currentTarget.style.boxShadow =
                                "0 12px 24px rgba(0,0,0,0.12)";
                              e.currentTarget.style.borderColor = border.hover;
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow =
                                "0 1px 3px rgba(0,0,0,0.08)";
                              e.currentTarget.style.borderColor =
                                border.default;
                            }}
                          >
                            {/* Card Header - Status Badges */}
                            <div
                              className="card-header border-0 pt-3 pb-2 px-3"
                              style={{
                                backgroundColor: "#ffffff",
                                minHeight: "50px",
                              }}
                            >
                              <div className="d-flex gap-2">
                                <span
                                  className={`flex-fill badge bg-${raffleStatus?.color} text-center py-2`}
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    letterSpacing: "0.3px",
                                    borderRadius: "6px",
                                  }}
                                  title={raffleStatus?.title}
                                >
                                  {raffleStatus?.text}
                                </span>
                                <span
                                  className="flex-fill badge bg-dark text-center py-2"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    letterSpacing: "0.3px",
                                    borderRadius: "6px",
                                  }}
                                  title={raffleType?.title}
                                >
                                  {raffleType?.text}
                                </span>
                              </div>
                            </div>

                            {/* Card Body */}
                            <div className="card-body d-flex flex-column p-3 pt-0">
                              {/* Title - Fixed Height with 4 lines support */}
                              <Link
                                to={`/raffle/default/${isMyCampaign ? `view` : `visit`}?campaign=${raffle?.campaign}${
                                  raffle?.key ? `&key=${raffle?.key}` : ""
                                }`}
                                className="text-decoration-none"
                              >
                                <div
                                  className="card-title py-3"
                                  title={raffle?.name}
                                >
                                  <div className="row col-md-11 mx-auto">
                                    <span className="badge bg-primary fs-5">
                                      {raffle?.name}
                                    </span>
                                  </div>
                                </div>
                              </Link>

                              {/* Image - Fixed Height */}
                              <Link
                                to={`/raffle/default/${isMyCampaign ? `view` : `visit`}?campaign=${raffle?.campaign}${
                                  raffle?.key ? `&key=${raffle?.key}` : ""
                                }`}
                              >
                                <div
                                  className="raffle-image-container overflow-hidden mb-3"
                                  style={{
                                    height: "200px",
                                    backgroundColor: "#f3f4f6",
                                    position: "relative",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <img
                                    src={raffle?.thumb}
                                    alt={raffle?.name}
                                    className="w-100 h-100"
                                    style={{
                                      objectFit: "cover",
                                      transition:
                                        "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1.08)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1)";
                                    }}
                                  />
                                </div>
                              </Link>

                              {/* Description - Fixed Height */}
                              <p
                                className="d-flex align-items-center justify-content-center text-muted text-center mb-3"
                                style={{
                                  fontSize: "0.85rem",
                                  lineHeight: "1.4",
                                  height: "3.5rem",
                                  display: "-webkit-box",
                                  WebkitLineClamp: "2",
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={raffle?.description_short}
                              >
                                {raffle?.description_short}
                              </p>

                              {/* Progress Bar */}
                              <div className="row mb-3">
                                <div className="col-12 mx-auto text-center">
                                  <span className="fw-semibold">
                                    {raffle?.ticketSoldProgress}% dos tickets
                                    foram vendidos.
                                  </span>
                                  <ProgressBar
                                    animated
                                    now={raffle?.ticketSoldProgress}
                                    label={`${raffle?.ticketSoldProgress}%`}
                                    variant="primary"
                                  />
                                </div>
                              </div>

                              {/* Stats Grid - Tickets Amount */}
                              <div className="row">
                                {/* Total Tickets Amount */}
                                <div className="col-6 d-flex flex-column gap-2 mb-3">
                                  <div
                                    className="p-2 text-center"
                                    style={{
                                      backgroundColor: "#f9fafb",
                                      borderRadius: "8px",
                                      border: "1px solid #e5e7eb",
                                    }}
                                    title="Quantidade total de Tickets"
                                  >
                                    <div className="d-flex flex-column">
                                      <span
                                        style={{
                                          fontSize: "0.7rem",
                                          color: "#9ca3af",
                                          fontWeight: "600",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Total
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "0.95rem",
                                          fontWeight: "700",
                                          color: "#1f2937",
                                        }}
                                      >
                                        {masks.formatMilhar(
                                          Number(raffle?.quantity),
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Total Sold Tickets Amount */}
                                <div className="col-6 d-flex flex-column gap-2 mb-3">
                                  <div
                                    className="p-2 text-center"
                                    style={{
                                      backgroundColor: "#f9fafb",
                                      borderRadius: "8px",
                                      border: "1px solid #e5e7eb",
                                    }}
                                    title="Quantidade total de Tickets Vendidos"
                                  >
                                    <div className="d-flex flex-column">
                                      <span
                                        style={{
                                          fontSize: "0.7rem",
                                          color: "#9ca3af",
                                          fontWeight: "600",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Vendido(s)
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "0.95rem",
                                          fontWeight: "700",
                                          color: "#1f2937",
                                        }}
                                      >
                                        {masks.formatMilhar(
                                          Number(raffle?.ticketSoldAmount),
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Stats Grid - Ticket | Reward Prices */}
                              <div className="row">
                                {/* Total Unit Price  */}
                                <div className="col-6 d-flex flex-column gap-2 mb-3">
                                  <div
                                    className="p-2 text-center"
                                    style={{
                                      backgroundColor: "#f9fafb",
                                      borderRadius: "8px",
                                      border: "1px solid #e5e7eb",
                                    }}
                                    title="Preço unitário do Ticket."
                                  >
                                    <div className="d-flex flex-column">
                                      <span
                                        style={{
                                          fontSize: "0.7rem",
                                          color: "#9ca3af",
                                          fontWeight: "600",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Preço Unitário
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "0.95rem",
                                          fontWeight: "700",
                                          color: "#1f2937",
                                        }}
                                      >
                                        {masks.brlCurrency(
                                          Number(raffle?.price),
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Reward Market Price Total */}
                                <div className="col-6 d-flex flex-column gap-2 mb-3">
                                  <div
                                    className="p-2 text-center"
                                    style={{
                                      backgroundColor: "#f9fafb",
                                      borderRadius: "8px",
                                      border: "1px solid #e5e7eb",
                                    }}
                                    title="Preço total do(s) prêmio(s)"
                                  >
                                    <div className="d-flex flex-column">
                                      <span
                                        style={{
                                          fontSize: "0.7rem",
                                          color: "#9ca3af",
                                          fontWeight: "600",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Prêmio Total
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "0.95rem",
                                          fontWeight: "700",
                                          color: "#1f2937",
                                        }}
                                      >
                                        {masks.brlCurrency(
                                          Number(raffle?.rewardPriceMarket),
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Campaign & Owner Info */}
                              <div className="d-flex flex-column gap-2 mb-2">
                                {/* Capaign Slug */}
                                <Link
                                  to={`/raffle/default/${isMyCampaign ? `view` : `visit`}?campaign=${raffle?.campaign}${
                                    raffle?.key ? `&key=${raffle?.key}` : ""
                                  }`}
                                >
                                  <div
                                    className="col-12 badge bg-info text-white fs-6"
                                    style={{
                                      color: "white",
                                      borderRadius: "8px",
                                      padding: "0.65rem 0.75rem",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                    }}
                                    onClick={() => {
                                      clickToCopy({
                                        text: `${window.location.origin}/campaign=${raffle?.campaign}`,
                                        onSuccess: () =>
                                          pushToastify({
                                            message: "Copiado com sucesso!",
                                            type: "success",
                                            theme: "dark",
                                          }),
                                        onError: () =>
                                          pushToastify({
                                            message: "Falha ao copiar.",
                                            type: "error",
                                            theme: "dark",
                                          }),
                                      });
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#111827";
                                      e.currentTarget.style.transform =
                                        "translateY(-1px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#1f2937";
                                      e.currentTarget.style.transform =
                                        "translateY(0)";
                                    }}
                                    title="Clique para copiar o link da campanha"
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span
                                        style={{
                                          opacity: 0.85,
                                        }}
                                      >
                                        Campanha:
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "700",
                                          fontFamily: "monospace",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        #{raffle?.campaign}
                                      </span>
                                    </div>
                                  </div>
                                </Link>

                                {/* Campaign Code | URL */}
                                <div
                                  className="col-12 badge text-black fs-6"
                                  style={{
                                    color: "white",
                                    borderRadius: "8px",
                                    padding: "0.65rem 0.75rem",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                  }}
                                  onClick={() => {
                                    clickToCopy({
                                      text: raffle?.campaign,
                                      onSuccess: () =>
                                        pushToastify({
                                          message: "Copiado com sucesso!",
                                          type: "success",
                                          theme: "dark",
                                        }),
                                      onError: () =>
                                        pushToastify({
                                          message: "Falha ao copiar.",
                                          type: "error",
                                          theme: "dark",
                                        }),
                                    });
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(-1px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(0)";
                                  }}
                                  title={`Clique para copiar a URL desta Campanha.`}
                                >
                                  <div className="d-flex align-items-center justify-content-between">
                                    <span
                                      style={{
                                        opacity: 0.85,
                                      }}
                                    >
                                      <FaRegCopy />
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: "700",
                                        fontFamily: "monospace",
                                        letterSpacing: "0.3px",
                                      }}
                                    >
                                      #{raffle?.campaign}
                                    </span>
                                  </div>
                                </div>

                                {/* Owner Info | Profile */}
                                <Link
                                  to={`/profile?atsign=${raffle.customerData.atSign}`}
                                >
                                  <div
                                    className="col-12 badge bg-black text-white fs-6"
                                    style={{
                                      color: "white",
                                      borderRadius: "8px",
                                      padding: "0.65rem 0.75rem",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#374151";
                                      e.currentTarget.style.transform =
                                        "translateY(-1px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#4b5563";
                                      e.currentTarget.style.transform =
                                        "translateY(0)";
                                    }}
                                    title={`Proprietário: ${formatName(raffle?.customerData?.name)}`}
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span
                                        style={{
                                          opacity: 0.85,
                                        }}
                                      >
                                        Proprietário:
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "700",
                                          fontFamily: "monospace",
                                          letterSpacing: "0.3px",
                                        }}
                                      >
                                        @{raffle?.customerData?.atSign}
                                      </span>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            </div>

                            {/* Card Footer - Date Info */}
                            <div
                              className="card-footer border-0 px-3 pb-3 pt-0"
                              style={{
                                backgroundColor: "#ffffff",
                                minHeight: "70px",
                              }}
                            >
                              <div className="d-flex flex-column mt-2 gap-2">
                                <div
                                  className="d-flex justify-content-between align-items-center py-1 px-2"
                                  style={{
                                    color: "#6b7280",
                                    backgroundColor: "#f9fafb",
                                    borderRadius: "6px",
                                  }}
                                >
                                  <span style={{ fontWeight: "600" }}>
                                    Criada:
                                  </span>
                                  <span
                                    style={{
                                      fontWeight: "700",
                                      color: "#374151",
                                      fontFamily: "monospace",
                                    }}
                                  >
                                    {dayjs(raffle?.createdAt).format(
                                      "DD/MM/YY HH:mm",
                                    )}
                                  </span>
                                </div>

                                {raffle?.finishedAt ? (
                                  <div
                                    className="d-flex justify-content-between align-items-center py-1 px-2"
                                    style={{
                                      color: "#6b7280",
                                      backgroundColor: "#f9fafb",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    <span style={{ fontWeight: "600" }}>
                                      Finalizada:
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: "700",
                                        color: "#374151",
                                        fontFamily: "monospace",
                                      }}
                                    >
                                      {dayjs(raffle?.finishedAt).format(
                                        "DD/MM/YY HH:mm",
                                      )}
                                    </span>
                                  </div>
                                ) : (
                                  <div className="text-center py-1">
                                    <span
                                      className="badge bg-success"
                                      style={{
                                        fontSize: "0.7rem",
                                        fontWeight: "700",
                                        padding: "0.4rem 1rem",
                                        letterSpacing: "0.3px",
                                      }}
                                    >
                                      EM ANDAMENTO
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Card>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>

              <div
                className="d-flex justify-content-between align-items-center mt-4 pt-3"
                style={{ borderTop: "1px solid #e5e7eb" }}
              >
                <div className="">
                  <span
                    style={{
                      fontSize: "0.875rem",
                      color: "#6b7280",
                      fontWeight: "500",
                    }}
                  >
                    Página {page} de {totalPages} página
                    {totalPages > 1 ? `s` : ``} ({masks.formatMilhar(total)}{" "}
                    registro
                    {total > 1 ? `s` : ``} encontrado{total > 1 ? `s` : ``})
                  </span>
                </div>
                <div className="">
                  <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    maxPageShow={5}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </Card>
    </>
  );
}
